import { CommonModule } from '@angular/common';
import { Component, effect, input, signal, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { combineLatest, map, tap } from 'rxjs';
import { MenuCollapseItemComponent } from '../menu-collapse-item/menu-collapse-item.component';
import { HoveredLeftMenuDirective } from '../../directives/hoveredLeftMenu.directive';
import { NavigationItem } from '../../interfaces/navigationList.interface';
import { PageContainerService } from '../../services/page-container.service';

@Component({
    selector: 'st-icon-button',
    imports: [
        CommonModule,
        TooltipModule,
        HoveredLeftMenuDirective,
        MenuCollapseItemComponent,
        RouterModule,
    ],
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IconButtonComponent {
  navigationItem = input.required<NavigationItem>();

  isActive = signal(false);
  canHover = signal(false);
  menuOptions: any = {
    autoClose: false,
    menuWidth: '260px',
  };

  menuExpanded$ = this.pageContainerService.menuExpanded;
  activeSectionRoute$ = this.pageContainerService.activeSectionRoute;

  activeChild!: NavigationItem | null;

  combineExpandedActiveSection$ = combineLatest([
    this.activeSectionRoute$,
    this.menuExpanded$,
  ]).pipe(
    tap(([x, menuExpanded]) => {
      if (x && x.id === this.navigationItem()?.id) {
        this.getRoutePath(x);
        if (menuExpanded) {
          this.canHover.set(false);
        } else {
          this.canHover.set(this.navigationItem().children.length > 0);
        }
        this.isActive.set(true);
      } else {
        this.canHover.set(this.navigationItem().children.length > 0);
        this.isActive.set(false);
        this.activeChild = null;
      }
      if(this.navigationItem()?.id == 3 && this.router.url.includes('dispatch')) //3 indicate to dispatch route constant
      {
        this.isActive.set(true);
      }
    }),
    map(([x, menuExpanded]) => x),
  );

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
  ) {
    effect(
      () => {
        this.canHover.update(x => {
          return this.navigationItem().children.length > 0;
        });
      },
      { allowSignalWrites: true },
    );
  }

  onClick() {
    this.pageContainerService.activeSectionRoute.next(this.navigationItem());
  }

  getRoutePath(item: NavigationItem | null) {
    if (item) {
      let currentPath = this.pageContainerService
        .getRoutePath()
        .find(x => x.url === this.router.url.split('?')[0])?.routePath;

      const index = this.navigationItem().children.findIndex(
        y => y && currentPath && y.id === currentPath[1],
      );
      if (index === -1) {
        return;
      }
      this.activeChild = this.navigationItem().children[index];
    }
  }
}
